import {Vue, Component} from 'vue-property-decorator';
import {centerWinOptions, escapeHtml, getCurrency} from '@/utils/commonUtils';

@Component
export default class ArticleGridColumn extends Vue {
  public articleGridColumn: any = {
    index: {
      header: 'No.',
      name: 'index',
      align: 'center',
      minWidth: 60,
      formatter: (data: any): any => {
        return data.row.noticed ? '<div id="article_list"><div class="notice_article">공지</div></div>' : data.value;
      }
    },
    mallName: {
      header: '쇼핑몰',
      name: 'mallName',
      align: 'center',
      minWidth: 100,
      formatter: (): any => $('[name=mallNo] option:selected').text()
    },
    no: {
      header: '게시글 번호',
      name: 'no',
      align: 'center',
      minWidth: 80,
      formatter: (data: any): any => `<a class="articleNo" href="javascript:articlePopup(${data.row.no})" data-article-no="${data.row.no}">${data.row.no}</a>`
    },
    replyNo: {
      header: '게시글 번호',
      name: 'no',
      align: 'center',
      minWidth: 80,
      formatter: (data: any): any => `<a class="articleNo" href="javascript:articleReplyPopup(${data.row.no})" data-article-no="${data.row.no}">${data.row.no}</a>`
    },
    board: {
      header: '게시판',
      name: 'board',
      align: 'left',
      minWidth: 120,
      formatter: (): any => $('[name=boardNo] option:selected').text()
    },
    categoryNo: {
      header: '게시판 카테고리',
      name: 'categoryNo',
      align: 'left',
      minWidth: 120,
      formatter: (data: any): any => {
        if (data.row.category) {
          return `<div class="categoryName" data-category-name="${data.row.category.name}">${data.row.category.name ? data.row.category.name : ''}</div>`;
        }
      }
    },
    title: {
      header: '제목',
      name: 'title',
      align: 'left',
      minWidth: 200,
      formatter: function(data: any): any {
        return `<a style="text-decoration: underline;" href="javascript:articlePopup(${data.row.no})">${escapeHtml(data.row.title)}</a>`;
      }
    },
    replyTitle: {
      header: '제목',
      name: 'title',
      align: 'left',
      minWidth: 200,
      formatter: function(data: any): any {
        return `<a style="text-decoration: underline;" href="javascript:articleReplyPopup(${data.row.no})">${escapeHtml(data.row.title)}</a>`;
      }
    },
    opened: {
      header: '공개여부',
      name: 'opened',
      align: 'center',
      minWidth: 80,
      formatter: (data: any): any => (data.value ? '공개' : '비공개'),
      copyOptions: {
        useFormattedValue: true
      }
    },
    replyCount: {
      header: '답글수',
      name: 'replyCount',
      align: 'center',
      minWidth: 80,
      formatter: (data: any): any => `<span class="${data.value === 0 ? '' : 'replyCnt'}">${data.value}</span>`
    },
    replyYn: {
      header: '답글여부',
      name: 'replies',
      align: 'center',
      minWidth: 80,
      formatter: (data: any): any => {
        if (data.value) {
          return 'Y';
        } else {
          return 'N';
        }
      },
      copyOptions: {
        useFormattedValue: true
      }
    },
    replyYnForExcel: {
      header: '답글여부',
      name: 'replyYn',
      align: 'center',
      minWidth: 80,
      formatter: (data: any): any => {
        if (data.row.parentPostNo === null) {
          return '-';
        } else if (data.row.replyCount > 0 && data.row.parentPostNo !== null) {
          return 'Y';
        } else if (data.row.replyCount === 0 && data.row.parentPostNo !== null) {
          return 'N';
        } else {
          return '';
        }
      }
    },
    secreted: {
      header: '비밀글',
      name: 'secreted',
      align: 'center',
      minWidth: 80,
      formatter: (data: any): any => {
        if (data.value === true) {
          return 'Y';
        }
        return 'N';
      },
      copyOptions: {
        useFormattedValue: true
      }
    },
    recommendCount: {
      header: '추천수',
      name: 'recommendCount',
      align: 'center',
      minWidth: 80,
      formatter: ({ value }: { value: number }): any  => getCurrency(value),
    },
    readCount: {
      header: '조회수',
      name: 'readCount',
      align: 'center',
      minWidth: 80,
      formatter: (data: any): any => data.value.toLocaleString()
    },
    writeAdmin: {
      header: '작성자',
      name: 'writer',
      align: 'center',
      minWidth: 100,
      formatter: ({value}: any): any => {
        if (value === null) {
          return '잘못된 사용자';
        } else if (value !== null && value.type == 'MEMBER') {
          if (value.name) {
            return `<a style="text-decoration: underline;" href="javascript:window.open(\'\/member\/popup\/crm\/${value.no}\', \'회원정보\', '${centerWinOptions(1100, 980)}');">${value.name} (${value.no})</a>`;
          } else {
            return `<a style="text-decoration: underline;" href="javascript:window.open(\'\/member\/popup\/crm\/${value.no}\', \'회원정보\', '${centerWinOptions(1100, 980)}');">${value.no}</a>`;
          }
        }
        return value.name;
      },
      copyOptions: {
        customValue: (value): string => {
          if (value == null) {
            return '잘못된 사용자';
          } else if (value !== null && value.type == 'MEMBER') {
            if (value.name) {
              return `${value.name} (${value.no})`;
            } else {
              return value.no;
            }
          }
          return value.name;
        }
      }
    },
    writeAdminForExcel: {
      header: '작성자',
      name: 'writer',
      align: 'center',
      minWidth: 100,
      formatter: (data: any): any => {
        if (data.row.writer.name == null) {
          if (!data.row.member) {
            return '잘못된 사용자';
          } else {
            const member = data.row.member;
            if (member.memberStatus == 'EXPELLED') {
              return '탈퇴회원';
            }
            if (member.memberIdView != '') {
              return `${member.memberIdView} (${member.memberNo})`;
            } else {
              return `${member.memberNo}`;
            }
          }
        }

        if (data.row.writer.type == 'MEMBER') {
          const member = data.row.writer;
          if (!data.row.writer.no) {
            return `${member.name}`;
          } else {
            return `${member.name} (${member.no})`;
          }
        }

        return data.row.writer.name;
      }
    },
    creationDateTime: {
      header: '작성일시',
      name: 'creationDateTime',
      align: 'center',
      minWidth: 150
    },
    editor: {
      header: '최종수정자',
      name: 'editor',
      align: 'center',
      minWidth: 100,
      formatter: ({value}: any): any => {
        if (value == null) {
          return '';
        } else if (value !== null && value.type == 'MEMBER') {
          if (value.name) {
            return `<a style="text-decoration: underline;" href="javascript:window.open(\'\/member\/popup\/crm\/${value.no}\', \'회원정보\', '${centerWinOptions(1100, 980)}');">${value.name} (${
              value.no
            })</a>`;
          } else {
            return `<a style="text-decoration: underline;" href="javascript:window.open(\'\/member\/popup\/crm\/${value.no}\', \'회원정보\', '${centerWinOptions(1100, 980)}');">${value.no}</a>`;
          }
        }
        return value.name;
      },
      copyOptions: {
        customValue: (value): string => {
          if (value == null) {
            return '';
          } else if (value !== null && value.type == 'MEMBER') {
            if (value.name) {
              return `${value.name} (${value.no})`;
            } else {
              return value.no;
            }
          }
          return value.name;
        }
      }
    },
    modifyAdminForExcel: {
      header: '최종수정자',
      name: 'editor',
      align: 'center',
      minWidth: 100,
      formatter: (data: any): any => {
        if (data.row.editor === null || data.row.editor.name === null) {
          if (!data.row.member) {
            return '';
          } else {
            const member = data.row.member;
            if (member.memberStatus == 'EXPELLED') {
              return '탈퇴회원';
            }
            if (member.memberIdView != '') {
              return `${member.memberIdView} (${member.memberNo})`;
            } else {
              return `${member.memberNo}`;
            }
          }
        }

        if (data.row.editor.type == 'MEMBER') {
          const member = data.row.editor;
          if (!data.row.editor.no) {
            return `${member.name}`;
          } else {
            return `${member.name} (${member.no})`;
          }
        }

        return data.row.editor.name;
      }
    },
    modificationDateTime: {
      header: '최종수정일시',
      name: 'modificationDateTime',
      align: 'center',
      minWidth: 150,
      formatter: (data: any): any => {
        if (data.value === null) {
          return '';
        }
        return data.value;
      }
    }
  };
}
